import React from 'react';
import PropTypes from 'prop-types';
import { mapCreatorConnect } from '../../higher-order-components';
import classNames from 'classnames';

class MapCreatorMarkerTypeSelector extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hovered_item: null
    };

    this.generateIconContainerClassName = this.generateIconContainerClassName.bind(this);
    this.generateIconImageClassName = this.generateIconImageClassName.bind(this);

    this.mounted = false;
  }

  generateIconContainerClassName(current_icon_url) {
    const { mapCreator: { deleting_markers }, selected_marker_icon } = this.props;
    return classNames({
      'map-marker-container': true,
      'selected': (
        (
          !deleting_markers &&
          selected_marker_icon &&
          selected_marker_icon.file_data &&
          selected_marker_icon.file_data.url == current_icon_url
        ) ||
        (
          deleting_markers &&
          this.state.hovered_item == current_icon_url
        )
      ),
    });
  }
  generateIconImageClassName(current_icon_url) {
    const { deleting_markers } = this.props.mapCreator;
    return classNames({
      'animated pulse infinite': deleting_markers == true,
      'animated pulse': !deleting_markers && this.state.hovered_item == current_icon_url
    });
  }
  componentDidMount() {
    this.mounted = true;
  }
  componentWillUnmount() {
    this.mounted = false;
  }

  render() {
    const { marker_types, deleting_markers } = this.props.mapCreator;
    if(marker_types) {
      return (
        <div className={'map-creator-marker-types-selector-container'}>
          {marker_types.map(marker_type => {
            const { url } = marker_type.file_data;
            return (
              <div
                className={this.generateIconContainerClassName(url)}
                key={url}
                >
                <img
                  className={this.generateIconImageClassName(url)}
                  src={url}
                  onMouseEnter={() => this.mounted ? setTimeout(this.setState({ hovered_item : url }), 20) : null}
                  onMouseLeave={() => this.setState({ hovered_item : null })}
                  onClick={() => this.props.handleSelectMarker(marker_type)}
                />
              </div>
            )
          })}
          {/* Adding fillers for flex justification */}
          {marker_types.length % 4 != 0 ? (
            Array(4 - (marker_types.length % 4)).fill(0).map((e, idx) => (
              <div
                className='map-marker-container'
                key={`map-marker-types-selector-filler-${idx}`}
              />
            ))
          ) : null}
        </div>
      )
    }

    return <div></div>
  }
}

export default mapCreatorConnect(MapCreatorMarkerTypeSelector);



// WEBPACK FOOTER //
// ./src/browser/components/map-creator/map-creator-marker-type-selector.js